// material-ui
import { Link, Typography, Stack } from '@mui/material';
import Betalablogo from 'assets/images/betalab.png';
// import MainCard from './MainCard';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //
const copyrightYear = new Date().getFullYear();

const AuthFooter = () => (
    // <MainCard>
    <Stack direction="row" justifyContent="space-between">
        <Typography variant="subtitle2" component={Link} style={{ alignItems: 'center', paddingTop: 10 }} target="_blank" underline="hover">
            © {copyrightYear} Britam. All Rights Reserved
        </Typography>

        <Typography variant="subtitle2" style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="subtitle2" component={Link} target="_blank" underline="hover">
                Powered by{' '}
            </Typography>
            <Typography variant="subtitle2" component={Link} target="_blank" underline="hover">
                <img src={Betalablogo} alt="Betalogo" style={{ width: '100px', height: 'auto', marginLeft: '5px', marginTop: '5px' }} />
            </Typography>
        </Typography>
    </Stack>
);

export default AuthFooter;
